import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getSession = async (
  orgId: string,
  sessionId: string,
): Promise<PublicSession> => {
  const response = await axiosClient.get(`${orgId}/sessions/${sessionId}`);
  return response.data;
};

export function getSessionQueryKey({
  orgId,
  sessionId,
}: {
  orgId: string;
  sessionId: string;
}) {
  return ["session", orgId, sessionId];
}

export function useGetSession(
  sessionId: string,
  queryOptions?: Partial<UseQueryOptions<PublicSession, HttpError>>,
) {
  const { organisation } = useOrganisation();
  return useQuery({
    queryKey: getSessionQueryKey({ orgId: organisation.id, sessionId }),
    queryFn: () => getSession(organisation.id, sessionId),
    ...queryOptions,
  });
}
